import React from 'react';
import ConsultingDetail from './ConsultingDetail';
import consultingData from '../data/consultingData';

const Consulting = () => {
  return (
    <main className="page consulting-page">
      {/* Hero / Intro */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Consulting</h1>
          <p className="page-subtitle">
            Practical, outcomes-driven advisory across strategy, operations, digital, governance,
            and transformation. Explore our services below.
          </p>
        </div>
      </section>

      {/* List / Accordion (desktop sidebar + mobile accordion) */}
      <section className="page-body">
        <div className="container">
          <ConsultingDetail consultingData={consultingData} />
        </div>
      </section>
    </main>
  );
};

export default Consulting;
